import { NzSkeletonParagraph, NzSkeletonTitle } from "ng-zorro-antd/skeleton";
export interface Style {
  width?: string;
  height?: string;
  border?: string;
  display?: string;
  backgroundColor?: string;
  "align-items"?: string;
  "justify-content"?: string;
  padding?: string;
}

export interface ChartConfig {
  title?: string;
  data: Array<number> | [90, 80, 70, 60, 50, 40, 30];
  chartHeight: string;
  style?: Style;
}

export interface ListConfig {
  noOfListItems: number | 5;
  listData?: number[];
  styleLi?: Style;
  styleUl?: Style;
}

export interface GridConfig {
  count: {
    row: number;
    column: number;
  };
}

export class CustomSkeletonConfig {
  nzTitle?: boolean | NzSkeletonTitle = true;
  nzActive?: boolean = true;
  nzParagraph?: boolean | NzSkeletonParagraph = false;
  nzLoading?: boolean = true;
  skeletonType: "default" | "list" | "grid" | "bar-chart";
  defaultConfig?: boolean = true;
  config?: {
    chart?: ChartConfig;
    list?: ListConfig;
    grid?: GridConfig;
  };
}
